module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/en/2-5f3797a9ff82456c86453838a23fafa2.jpg";